<template>
  <div class="py-16" :class="{ 'bg-putty': backgroundGray }">
    <CardSlider :items="articles" :heading="heading" :breakpoints="breakpoints">
      <ArticlePreview
        v-for="(article, index) in articles"
        :key="article.id"
        v-track:view="gtmData(article, index)"
        v-track:click="gtmData(article, index)"
        :article="article"
        data-test-id="article"
      />
    </CardSlider>
  </div>
</template>
<script>
import ArticlePreview from '@/components/article/ArticlePreview';
import CardSlider from '@/components/common/CardSlider';

export default defineNuxtComponent({
  name: 'ArticleRowSlide',
  components: {
    CardSlider,
    ArticlePreview,
  },
  props: {
    heading: {
      type: String,
      default: '',
    },
    backgroundGray: {
      type: Boolean,
      default: true,
    },
    articles: {
      type: Array,
      default: () => [],
    },
    blockPosition: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      breakpoints: [
        {
          minWindowWidth: 0,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
        {
          minWindowWidth: 700,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
        {
          minWindowWidth: 1000,
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      ],
    };
  },

  methods: {
    gtmData(payload, index) {
      return {
        promotion_id: payload.uri,
        promotion_name: [this.$route?.name, payload.title].join(' / '),
        creative_name: 'articleRowSlide',
        creative_slot: [this.$route?.name, this.blockPosition + 1, index + 1].join(' / '),
      };
    },
  },
});
</script>
